<template>
  <div class="container">
    <div class="bread">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item class="bread1" :to="{ path: '/' }"
          >| 首页</el-breadcrumb-item
        >
        <el-breadcrumb-item class="bread1"
          ><span style="color: red; user-select: none"
            >产权需求项目详情</span
          ></el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>
    <!-- 项目图片轮播展示 -->
    <div style="position: relative; margin-bottom: 20px">
      <div style="display: flex">
        <div class="particulars">
          <div class="slideshow">
            <el-carousel
              :interval="5000"
              arrow="always"
              height="380px"
              ref="carousel"
            >
              <el-carousel-item
                v-for="(item, index) in projectDetail.imgList"
                :key="index"
              >
                <img
                  :src="item"
                  style="width: 100%; height: 380px; margin: 0 auto"
                />
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="lunbo-bottom">
            <div
              v-for="(item, index) in projectDetail.imgList"
              :key="index"
              class="lunbo-item"
              @click="qiehuanlunbo(index)"
            >
              <img :src="item" style="width: 100%; height: 100%" />
            </div>
          </div>
        </div>
        <!-- 右侧商品详细栏 -->
        <div class="left-xiangqing">
          <div class="top-title">
            <div style="color: #f56c6c; font-weight: 700">
              {{ projectDetail.deptName + projectDetail.projectname }}
            </div>
            <div class="sub-title">
              <span>项目编码： {{ projectDetail.numbering }} </span
              ><span
                >发布时间：
                {{ timeDetail.createTime ? timeDetail.createTime : "" }}
              </span>
            </div>
          </div>
          <div style="display: flex">
            <div class="left-bottom" style="flex: 1">
              <div>
                需求方名称：<span class="miaoshu">
                  {{ projectDetail.needname }}
                </span>
              </div>
              <div>
                联系人地址：<span class="miaoshu">
                  {{ projectDetail.address }}
                </span>
              </div>
              <div class="miaoshuBox">
                联系人电话：<span
                  class="miaoshu"
                  :title="realPhone || projectDetail.phone"
                >
                  {{ realPhone || projectDetail.phone }}
                  <img
                    src="../assets/img/openEye.png"
                    style="width: 30px; height: 30px; cursor: pointer"
                    @click="checkShowPhone"
                  />
                </span>
              </div>
              <div>
                项目名称：<span class="miaoshu">
                  {{ projectDetail.projectname }}
                </span>
              </div>
              <div>
                承受价格：<span class="miaoshu">
                  {{ projectDetail.price }}
                  {{
                    cityDetail.changePriceUnit && projectDetail.number == "104"
                      ? "元/"
                      : "元/年/"
                  }}{{ projectDetail.unit }}
                </span>
              </div>
              <div v-if="projectDetail.status > 6">
                中标价格：<span class="miaoshu">
                  {{ currentPrice }}
                  {{
                    cityDetail.changePriceUnit && projectDetail.number == "104"
                      ? "元/"
                      : "元/年/"
                  }}{{ projectDetail.unit }}</span
                >
              </div>
              <div v-if="!cityDetail.notShowWatchNum">
                报名人次：<span class="miaoshu">
                  {{ projectDetail.signCts }}人
                </span>
              </div>
              <div>
                浏览次数：<span class="miaoshu">
                  {{ projectDetail.watchCts ? projectDetail.watchCts : 0 }}次
                </span>
              </div>
              <div
                v-if="projectDetail.status == 2 || projectDetail.status >= 7"
              >
                公示时间：<span class="miaoshu"
                  >{{ timeDetail.publicityStartTime }} 至
                  {{ timeDetail.publicityStopTime }}</span
                >
              </div>
              <div
                v-if="
                  (projectDetail.status <= 4 && projectDetail.status >= 2) ||
                  projectDetail.status >= 7
                "
              >
                报名时间：<span class="miaoshu"
                  >{{ timeDetail.applyStartTime }} 至
                  {{ timeDetail.applyStopTime }}</span
                >
              </div>
              <div>
                {{ cityDetail.bidTimeName || "竞价时间" }}：<span
                  class="miaoshu"
                  >{{ timeDetail.biddingStartTime }} 至
                  {{ timeDetail.biddingStopTime }}</span
                >
              </div>
              <div v-if="projectDetail.status == 6 && isApply">
                当前价格：<span class="miaoshu"
                  >{{ currentPrice }}
                  {{
                    cityDetail.changePriceUnit && projectDetail.number == "104"
                      ? "元/"
                      : "元/年/"
                  }}{{ projectDetail.unit }}</span
                >
              </div>
              <div
                style="display: flex; align-items: center; height: 50px"
                v-if="projectDetail.status == 6 && isApply == 1"
              >
                出价：

                <el-input
                  v-model="money"
                  class="input-number"
                  @blur="moneyBlur"
                ></el-input>
                {{
                  cityDetail.changePriceUnit && projectDetail.number == "104"
                    ? "元/"
                    : "元/年/"
                }}{{ projectDetail.unit }}
              </div>
              <div class="gobutton" v-if="projectDetail.status == 2">
                公示中
              </div>
              <div class="gobutton1" v-if="projectDetail.status == 3">
                公示结束
              </div>
              <div
                class="gobutton"
                @click="toChanquanbaoming"
                v-if="projectDetail.status == 4 && isApply == 0"
              >
                我要报名
              </div>
              <div
                class="gobutton"
                v-if="projectDetail.status == 4 && isApply == 1"
              >
                报名成功
              </div>
              <div
                class="gobutton"
                v-if="projectDetail.status == 4 && isApply == 2"
              >
                已报名待审核
              </div>
              <div class="gobutton1" v-if="projectDetail.status == 5">
                报名结束
              </div>
              <div
                class="gobutton1"
                v-if="projectDetail.status == 6 && isApply == 1"
                @click="cityDetail.affirmMoney ? showAffirmMoney : bid"
              >
                我要出价
              </div>
              <div
                class="gobutton1"
                v-if="projectDetail.status == 6 && isApply != 1"
              >
                未报名
              </div>

              <div
                class="gobutton1"
                v-if="projectDetail.status >= 7 && projectDetail.status < 19"
              >
                已结束
              </div>
            </div>
            <div
              style="
                flex: 1;
                padding: 0 16px;
                border-left: 1px solid #d9d9d9;
                margin: 16px 0;
                height: auto;
              "
            >
              <div v-if="projectDetail.status < 4">
                距离报名开始：<span style="font-size: 28px; font-weight: 600"
                  >{{ nowDay }}天{{ nowHour }}时{{ nowMinute }}分{{
                    nowSecond
                  }}秒</span
                >
              </div>
              <div v-if="projectDetail.status == 4">
                距离报名截止仅剩<span style="font-size: 28px; font-weight: 600"
                  >{{ nowDay }}天{{ nowHour }}时{{ nowMinute }}分{{
                    nowSecond
                  }}秒</span
                >
              </div>
              <div
                v-if="
                  cityDetail.applyShowBidTime
                    ? projectDetail.status == 6 && isApply == 1
                    : projectDetail.status == 6
                "
              >
                距离竞价截止仅剩<span style="font-size: 28px; font-weight: 600"
                  >{{ nowDay }}天{{ nowHour }}时{{ nowMinute }}分{{
                    nowSecond
                  }}秒</span
                >
              </div>
              <div
                class="msg"
                v-if="
                  projectDetail.status >= 5 && cityDetail.showBiddingMessage
                "
              >
                <div class="msgTitle">系统消息</div>
                <div class="msgContent">
                  <span v-if="projectDetail.status >= 7"
                    >感谢各位竞买人积极参与，本次竞价会已圆满结束，欢迎各位竞买人后续积极关注本网站获取更多信息。
                    {{ timeDetail.biddingStopTime }}</span
                  >
                  <span v-if="projectDetail.status >= 6"
                    >竞价会已开始，请各位有意向的竞买人尽快出价！
                    {{ timeDetail.biddingStartTime }}</span
                  >
                  <span v-if="projectDetail.status >= 5"
                    >竞价会即将开始，为避免错过竞价会，请各位竞买人提前15分钟登录账号，竞价过程中出现任何问题及时拨打项目负责人电话咨询。
                    {{ timeDetail.applyStopTime }}</span
                  >
                </div>
              </div>
              <div style="display: flex; flex-direction: column; height: 400px">
                <div
                  style="
                    background-color: #f56c6c;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 10px 10px 0 0;
                  "
                >
                  <span
                    style="
                      color: #fff;
                      font-size: 30px;
                      font-family: Source Han Sans CN-Regular,
                        Source Han Sans CN;
                      padding: 8px 0;
                      font-weight: 400;
                      height: 54px;
                    "
                    ><span
                      v-if="
                        (projectDetail.status == 6 && isApply == 1) ||
                        cityDetail.showAuctionRecords
                      "
                      >出价记录</span
                    ></span
                  >
                </div>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    max-height: 85%;
                    overflow: auto;
                    padding: 0 20px;
                  "
                  v-if="
                    (projectDetail.status == 6 && isApply == 1) ||
                    cityDetail.showAuctionRecords
                  "
                >
                  <div
                    v-for="(data, index) in auctionRecords"
                    :key="index"
                    class="list"
                    :class="{
                      nowUserBid:
                        userInfo &&
                        cityDetail.nowUserBidChangeColor &&
                        data.username == userInfo.userName,
                    }"
                  >
                    <span style="flex: 1">{{
                      cityDetail.notShowAuctionRecordsName
                        ? "xxx"
                        : cityDetail.showPhoneId
                        ? (data.phone + data.id).slice(-4)
                        : data.realname
                    }}</span>
                    <span style="flex: 2">{{ data.createTime }}</span>
                    <span
                      style="flex: 1; text-align: right; white-space: nowrap"
                      >{{ data.money }}
                      {{
                        cityDetail.changePriceUnit &&
                        projectDetail.number == "104"
                          ? "元/"
                          : "元/年/"
                      }}{{ projectDetail.unit }}</span
                    >
                  </div>
                </div>
              </div>
              <div style="font-size: 20px; color: red">
                <i class="el-icon-warning"></i
                >重要提示:报价过程数据仅体现标的价格，不包含服务费!
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FLOW />
    <!-- 底部商品详细及交易须知 -->
    <HJXNeedProjectDetail
      v-if="cityDetail.cityName == '获嘉县'"
      :projectDetail="projectDetail"
      :dicts="dicts"
      :backCardInfo="backCardInfo"
      :isLogin="isLogin"
    />
    <HXSNeedProjectDetail
      v-else-if="cityDetail.cityName == '辉县市'"
      :projectDetail="projectDetail"
      :dicts="dicts"
      :backCardInfo="backCardInfo"
      :isLogin="isLogin"
    />
    <needProjectDetail
      v-else
      :projectDetail="projectDetail"
      :dicts="dicts"
      :backCardInfo="backCardInfo"
      :isLogin="isLogin"
    />
    <el-dialog
      title="出价确认提示"
      :visible.sync="showAffirmMoneyDialog"
      width="700px"
    >
      <span style="font-size: 30px">
        您当前出价为：{{ money }}元，请确认是否出价。
      </span>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button
          type="primary"
          @click="bid"
          style="font-size: 20px; padding: 6px 10px"
        >
          确 认</el-button
        ><el-button
          type="info"
          @click="showAffirmMoneyDialog = false"
          style="font-size: 20px; padding: 6px 10px"
        >
          关 闭</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { checkToken, getPhoneById, getUserInfoByUserId } from '../api/login'
import { getProList } from '../api/交易项目'
import needProjectDetail from "../components/需求项目商品详细_默认版本.vue"
import HJXNeedProjectDetail from "../components/需求项目商品详细_获嘉版本.vue"
import HXSNeedProjectDetail from "../components/需求项目商品详细_辉县版本.vue"
import {
  auctionBid,
  getCurrentPrice,
  getTypeList,
  isApply,
  watchProject,
  getBankCardInfo,
  getInfoByDeptId,
} from '../api/交易项目详情'
import FLOW from "../components/Home/First/交易流程.vue"
import { getNeedProjectDetail } from '../api/产权需求'
import mainOption, { cityDetail } from '../util/mainOption'
import { getNewsDetail, getNewslist } from '../api/mian'
export default {
  computed: {
    delayTimeSocket () {
      return this.$store.state.delayTime
    },
    auctionBidSocket () {
      return this.$store.state.auctionBid
    },
  },
  watch: {
    delayTimeSocket (nval, oval) {
      if (nval == true && this.$store.state.delayTimeData.dataId == this.$route.query.id && this.$store.state.delayTimeData.dataType == "3") {
        clearInterval(this.timer)
        let data = {
          id: this.$route.query.id,
        }
        getNeedProjectDetail(data).then((res) => {
          this.projectDetail = res.data.data
          this.timeDetail = this.projectDetail.releaseRecord //获取接口报名时间那一块数据
          // 设置倒计时时间
          this.rebootCountDown()
        })
      }
      this.$store.state.delayTime = false
    },
    auctionBidSocket (nval, oval) {
      if (nval == true && this.$store.state.auctionBidData.dataId == this.$route.query.id && this.$store.state.auctionBidData.dataType == "3") {
        this.getNowPrice()
      }
      this.$store.state.auctionBid = false
    },
  },
  data () {
    return {
      // 查看区域下标
      getDetailActive: '1',
      // 当前地级名称
      deptName: '',
      // 项目详情
      projectDetail: {},
      // 时间详情
      timeDetail: {},
      // 出价记录
      auctionRecords: [],
      // 交纳保证金账户信息
      backCardInfo: {},
      // 当前价格
      currentPrice: -999,
      // 计时器
      timer: null,
      // 当前天数
      nowDay: 0,
      // 当前小时
      nowHour: 0,
      // 当前分钟
      nowMinute: 0,
      // 当前秒数
      nowSecond: 0,
      // 账户报名状态
      isApply: 0, //0未报名,1已报名2已报名未审核
      // 价格计时器
      priceTimer: null,
      // 当前出价金额
      money: '',
      // token验证是否通过
      isLogin: false,
      // 字典列表
      dicts: {
        // 小类型列表
        numberList: [],
        // 需求方类型列表
        companyList: [],
        // 公司类型列表
        companyTypeList: [],
        // 交易方式列表
        transTypeList: [],
      },
      // 小分类列表
      classTypeList: [],
      userInfo: {},
      showPhone: false,
      // 是否出价弹窗
      showAffirmMoneyDialog: false,
      // 报名方式 html
      applyWay: "",
      // 报名须知 html
      bmxzContent: "",
      // 竞拍须知 html
      jpxzContent: "",
      realPhone: "",
    }
  },
  components: {
    FLOW,
    needProjectDetail,
    HJXNeedProjectDetail,
    HXSNeedProjectDetail,
  },
  async mounted () {
    getNewslist({
      number: '021',
      pageSize: 1,
      pageNum: 1,
      deptId: sessionStorage.getItem('deptId') || cityDetail.deptId,
    }).then(res => {
      res.data.rows.length > 0 && getNewsDetail({ id: res.data.rows[0].id }).then(res => {
        this.applyWay = res.data.data.content
        console.log("报名方式新闻详情", this.applyWay)
      })
    })
    getNewslist({
      number: '022',
      pageSize: 1,
      pageNum: 1,
      deptId: sessionStorage.getItem('deptId') || cityDetail.deptId,
    }).then(res => {
      res.data.rows.length > 0 && getNewsDetail({ id: res.data.rows[0].id }).then(res => {
        this.bmxzContent = res.data.data.content
        console.log("报名须知新闻详情", this.bmxzContent)
      })
    })
    getNewslist({
      number: '023',
      pageSize: 1,
      pageNum: 1,
      deptId: sessionStorage.getItem('deptId') || cityDetail.deptId,
    }).then(res => {
      res.data.rows.length > 0 && getNewsDetail({ id: res.data.rows[0].id }).then(res => {
        this.jpxzContent = res.data.data.content
        console.log("竞拍须知新闻详情", this.jpxzContent)
      })
    })
    if (this.$route.query.id) {
      await getNeedProjectDetail(this.$route.query).then((res) => {
        if (!res.data.data) {
          this.$message.error('无该项目信息')
          return
        }
        this.projectDetail = res.data.data
        this.timeDetail = this.projectDetail.releaseRecord //获取接口报名时间那一块数据
        // console.log('请求成功')
        getInfoByDeptId(this.projectDetail.pid).then((res) => {
          this.backCardInfo = res.data.data
        })
      })
    }
    getProList({ type: 3 }).then((res) => {
      // console.log('已打印')
      this.classTypeList = res.data.data
    })
    getTypeList('poperty_type').then((res) => {
      this.dicts.numberList = res.data.data
    })
    getTypeList('need_type').then((res) => {
      this.dicts.companyList = res.data.data
    })
    getTypeList('company_type').then((res) => {
      this.dicts.companyTypeList = res.data.data
    })
    getTypeList('trans_type').then((res) => {
      this.dicts.transTypeList = res.data.data
    })
    this.deptName = localStorage.getItem('deptName')
      ? localStorage.getItem('deptName')
      : this.cityDetail.cityName
    getCurrentPrice({
      projectId: this.$route.query.id,
      projectType: 3,
    }).then((res) => {
      this.currentPrice = res.data.data.currentPrice
        ? res.data.data.currentPrice
        : res.data.data.initPrice
      this.auctionRecords = res.data.data.auctionRecords
    })
    if (localStorage.getItem('token')) {
      checkToken().then((res) => {
        if (res.data.code == 200) {
          this.isLogin = true
          getUserInfoByUserId().then((res) => {
            this.userInfo = res.data.data
          })
          isApply({ projectId: this.projectDetail.id, projectType: 3 }).then(
            (res) => {
              this.isApply = res.data.data
              getCurrentPrice({
                projectId: this.$route.query.id,
                projectType: 3,
              }).then((res) => {
                this.currentPrice = res.data.data.currentPrice
                  ? res.data.data.currentPrice
                  : res.data.data.initPrice

                this.auctionRecords = res.data.data.auctionRecords
              })
            }
          )
        }
      })
    }
    this.rebootCountDown()
    watchProject({ dataId: this.projectDetail.id, type: 3 })
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  methods: {
    // 确认出价弹窗
    showAffirmMoney () {
      if (this.money || this.money == '0') {
        this.showAffirmMoneyDialog = true
      } else {
        this.$message.warning('请输入出价金额')
      }
    },
    moneyBlur () {
      getCurrentPrice({
        projectId: this.$route.query.id,
        projectType: 3,
      }).then((res) => {
        if (Number(this.money) < 0) {
          this.$message.warning("出价金额不能小于0")
        } else if (res.data.data.currentPrice ? Number(this.money) >= Number(this.currentPrice) : Number(this.money) > Number(this.currentPrice)) {
          this.$message.warning('出价须小于当前价格')
        }
      })
    },
    // 手机号小眼睛点击事件
    checkShowPhone () {
      if (this.realPhone) return
      if (!localStorage.getItem('token')) {
        this.$message.warning("请登录后查看！")
        return
      }
      getPhoneById({
        id: this.projectDetail.id,
        projectType: 3
      }).then(res => {
        if (res.data.code == 200) {
          this.realPhone = res.data.msg
        }
      })
    },
    // 获取小分类列表
    getClassList (list, id) {
      return list.filter((item) => {
        return item.code == id
      })[0]
        ? list.filter((item) => {
          return item.code == id
        })[0].name
        : ''
    },
    // 获取字典内容方法
    getDictsVal (list, val) {
      if (!!list && !!val) {
        return list.filter((item) => {
          return item.dictValue == val
        })[0]
          ? list.filter((item) => {
            return item.dictValue == val
          })[0].dictLabel
          : ''
      }
      return ''
    },
    getYearLimit () {
      let start = new Date(this.projectDetail.needstarttime)
      let stop = new Date(this.projectDetail.needstoptime)
      return (
        (Number(stop.getTime()) - Number(start.getTime())) /
        (1000 * 60 * 60 * 24 * 30 * 12)
      ).toFixed(1)
    },
    bid () {
      if (this.auctionRecords.length > 0 && this.userInfo.phone == this.auctionRecords[0].phone) {
        this.$message.warning('您是当前最低出价人,请等待其他出价人')
        getCurrentPrice({
          projectId: this.$route.query.id,
          projectType: 3,
        }).then((res) => {
          this.currentPrice = res.data.data.currentPrice
            ? res.data.data.currentPrice
            : res.data.data.initPrice
          this.auctionRecords = res.data.data.auctionRecords
          this.showAffirmMoneyDialog = false
        })
        return
      }
      getCurrentPrice({
        projectId: this.$route.query.id,
        projectType: 3,
      }).then((res) => {
        if (
          (res.data.data.currentPrice ? Number(this.money) < Number(this.currentPrice) : Number(this.money) <= Number(this.currentPrice)) && Number(this.money) >= 0
        ) {
          auctionBid({
            projectId: this.projectDetail.id,
            projectType: 3,
            money: this.money,
          }).then((res) => {
            if (res.data.code == 200) {
              this.$message.success('出价成功')
            }
          })
        } else {
          this.$message.error('出价须小于当前价格')
        }
        this.currentPrice = res.data.data.currentPrice
          ? res.data.data.currentPrice
          : res.data.data.initPrice
        this.auctionRecords = res.data.data.auctionRecords
        this.showAffirmMoneyDialog = false
      })
    },
    // 获取当前价格
    getNowPrice () {
      getCurrentPrice({ projectId: this.$route.query.id, projectType: 3 })
        .then((res) => {
          this.currentPrice = res.data.data.currentPrice
            ? res.data.data.currentPrice
            : res.data.data.initPrice
          this.auctionRecords = res.data.data.auctionRecords
        })
        .catch((err) => {
        })
    },
    // 重启计时器方法
    rebootCountDown () {
      this.timer = setInterval(async () => {
        let time
        if (this.projectDetail.status < 4) {
          time = await this.countDown(this.timeDetail.applyStartTime)
        } else if (this.projectDetail.status == 4) {
          time = await this.countDown(this.timeDetail.applyStopTime)
        } else if (this.projectDetail.status == 5) {
          time = await this.countDown(this.timeDetail.biddingStartTime)
        } else if (this.projectDetail.status == 6) {
          time = await this.countDown(this.timeDetail.biddingStopTime)
        } else if (this.projectDetail.status == 7) {
          time = await this.countDown(this.timeDetail.biddingStopTime)
        } else {
          clearInterval(this.timer)
          return
        }
        this.nowDay = time.day
        this.nowHour = time.hour
        this.nowMinute = time.minute
        this.nowSecond = time.second
      }, 1000)
    },
    // 倒计时方法
    countDown (endTime) {
      let now = new Date().getTime()
      let end = new Date(endTime).getTime()
      let time = {
        day: 0,
        hour: 0,
        minute: 0,
        second: 0,
      }
      if (now >= end) {
        clearInterval(this.timer)
        let data = {
          id: this.$route.query.id,
        }
        getNeedProjectDetail(data).then((res) => {
          this.projectDetail = res.data.data
          this.timeDetail = this.projectDetail.releaseRecord //获取接口报名时间那一块数据
        })
        return time
      }
      time.day = Math.floor((Number(end) - Number(now)) / (1000 * 60 * 60 * 24))
      time.hour = Math.floor(
        (Number(end) - Number(now) - time.day * 1000 * 60 * 60 * 24) /
        (1000 * 60 * 60)
      )
      time.minute = Math.floor(
        (Number(end) -
          Number(now) -
          (time.day * 1000 * 60 * 60 * 24 + time.hour * 1000 * 60 * 60)) /
        (1000 * 60)
      )
      time.second = Math.floor(
        (Number(end) -
          Number(now) -
          (time.day * 1000 * 60 * 60 * 24 +
            time.hour * 1000 * 60 * 60 +
            time.minute * 1000 * 60)) /
        1000
      )
      return time
    },
    // 报名按钮事件
    toChanquanbaoming () {
      if (localStorage.getItem('token') && this.isLogin) {
        this.$router.push({
          name: '产权报名',
          query: { id: this.projectDetail.id, type: 3 },
        })
      } else {
        this.$message.error('请先登录')
        if (cityDetail.homeShowLogin) {
          this.$router.push('/')
        } else {
          this.$router.push('/login')
        }
      }
    },
    // 获取项目详情
    getProjectDetail () {
      if (this.$route.query.id) {
        getNeedProjectDetail(this.$route.query).then((res) => {
          if (!res.data.data) {
            this.$message.error('无该项目信息')
            return
          }
          this.projectDetail = res.data.data
          this.timeDetail = this.projectDetail.releaseRecord //获取接口报名时间那一块数据
          if (this.projectDetail.status <= 6) {
            this.rebootCountDown()
          }
        })
      }
    },
    // 限制降价框输入
    btKeyDown (e) {
      e.target.value = e.target.value.replace(/[^0-9]/g, '')
    },
  },
}
</script>

<style>
/* 整个滚动条的样式 */
::-webkit-scrollbar {
  width: 10px; /* 滚动条宽度 */
}

/* 滚动轨道的样式 */
::-webkit-scrollbar-track {
  background: #fff; /* 轨道背景颜色 */
}

/* 滚动滑块的样式 */
::-webkit-scrollbar-thumb {
  background: #ddd; /* 滑块背景颜色 */
  border-radius: 200px;
}

/* 当鼠标悬停在滑块上时改变颜色 */
::-webkit-scrollbar-thumb:hover {
  background: #999; /* 鼠标悬停时的滑块颜色 */
}
</style>
<style scoped lang="scss">
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.nowUserBid {
  color: #ffb52b;
}
.msg {
  display: flex;
  flex-flow: column nowrap;
  border-radius: 8px;
  .msgTitle {
    color: #fff;
    background-color: #f56c6c;
    width: 120px;
    text-align: center;
    height: 40px;
    line-height: 40px;
    border-radius: 8px 8px 0 0;
    font-size: 20px;
  }
  .msgContent {
    display: flex;
    flex-flow: column nowrap;
    border: 1px solid #ec9191;
    margin-bottom: 8px;
    max-height: 140px;
    overflow-y: auto;
    padding: 4px 10px;
    span {
      font-size: 20px;
      text-indent: 2em;
      line-height: 32px;
      color: #ffb52b;
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
.imgcontent {
  display: flex;
  /* justify-content: s; */
  flex-wrap: wrap;
}

.lunbo-bottom {
  display: flex;
  /* border: 1px solid red; */
  margin-top: 7px;
  height: 110px;
}

.lunbo-item {
  width: 25%;
  margin-right: 5px;
  cursor: pointer;
}

.lunbo-item:last-child {
  margin-right: 0;
}

.top-title {
  height: 85px;
  border-bottom: #d1d1d2 1px solid;
  padding-left: 30px;
}

.left-bottom {
  font-size: 20px;
  padding: 30px;
  color: #666;
}

.left-bottom > div {
  line-height: 45px;
  height: 45px;
}

.gobutton {
  width: 200px;
  text-align: center;
  margin: 0 auto;
  background-color: #67c23a;
  border-radius: 10px;
  font-size: 25px;
  color: #fff;
  cursor: pointer;
  user-select: none;
}

.gobutton1 {
  width: 200px;
  text-align: center;
  margin: 0 auto;
  background-color: #f56c6c;
  border-radius: 10px;
  font-size: 25px;
  color: #fff;
  cursor: pointer;
  user-select: none;
  margin-top: 20px;
}

.miaoshu {
  color: #333;
}

.sub-title {
  color: #999;
  font-size: 18px;
  margin-top: 15px;
}

.sub-title span {
  margin-right: 50px;
}

.left-xiangqing {
  border: 1px solid #d1d1d2;
  flex: 1;
  margin-left: 30px;
  font-size: 26px;
  padding: 15px 0;
  color: #333;
}

* {
  padding: 0;
  margin: 0;
}

a {
  text-decoration: none;
  color: black;
}

.container {
  margin: 0 auto;
  width: 1860px;
  background-color: #fff;
  padding: 20px;
}

.bread {
  margin: 20px 0;
}

.bread1 {
  font-size: 18px;
}

.particulars {
  width: 30%;
  height: 100%;
}

.slideshow {
  width: 100%;
  /* height: 400px; */
  /* margin-top: 3%; */
  /* margin: /auto 0; */
}

.footer {
  display: flex;
  font-size: 22px;
}

.footerDiv {
  margin: 8px 0;
  font-weight: 600;
}

.footerTitle {
  font-size: 36px;
  height: 15px;
  /* border: #67C23A 1px solid; */
  /* margin-bottom: 40px; */
  color: #f56c6c;
  /* list-style: armenian; */
}

.fengexian {
  margin-bottom: 40px;
}

.fengexian >>> .el-divider__text {
  font-size: 36px;
  /* margin-bottom: 40px; */
  color: #f56c6c;
  list-style: armenian;
}

.fengexian1 {
  margin: 30px 0 50px 0;
}

.fengexian1 >>> .el-divider__text {
  font-size: 36px;
  /* margin-bottom: 40px; */
  color: #f56c6c;
  list-style: armenian;
}

.applyDetail {
  width: 85%;
  height: 55%;
  border: 1px solid #d1d1d2;
}

.left > div {
  margin: 25px 0;
}

.getdetail {
  font-size: 24px;
  padding: 0 30px;
  font-weight: 600;
  opacity: 0.5;
}

.getDetail {
  font-size: 24px;
  padding: 0 30px;
  border-top: 1px solid #f56c6c;
  background-color: white;
}

.gettimeDetail {
  color: #f56c6c;
  font-weight: 600;
}

.tet {
  border: 1px solid rgb(210, 210, 210);
  /* padding: 30px; */
  margin: 0 !important;
  display: flex;
}

.tet1 {
  min-width: 250px;
  max-width: 250px;
  border-right: 1px solid #f3f5f8;
  padding: 20px 20px;
  text-align: center;
  font-weight: 600;
  background-color: #f3f5f8;
}

.tet2 {
  padding: 20px 20px;
  width: 550px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tet3 {
  padding: 20px 20px;
  width: 550px;
  overflow: hidden;
  text-overflow: ellipsis;
  /* width: 100%; */
}

.money {
  display: flex;
  flex-direction: column;
}

.moneyTableTitle {
  display: flex;
  align-content: center;
}

.mtt {
  flex: 1;
  border: 1px solid #d2d2d2;
  padding: 20px;
  font-weight: 600;
  background-color: #f3f5f8;
}

.mtc {
  flex: 1;
  border: 1px solid #d2d2d2;
  padding: 20px;
}

.list {
  font-size: 20px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #606266;
  padding: 10px 0;
  border-bottom: 1px solid #606266;
  display: flex;
  justify-content: space-between;
}

.list:last-child {
  border-bottom: 0;
}

table {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  padding: 0;
  margin: 0;
  height: 100%;
}

table td {
  height: auto;
  text-align: left;
  table-layout: fixed;
  padding: 10px 6px;
  font-size: 20px;
  line-height: 100%;
  color: #000000;
  line-height: 40px;
}

table th {
  width: 15%;
  height: auto;
  text-align: left;
  table-layout: fixed;
  padding: 10px 6px;
  font-size: 20px;
  line-height: 100%;
  color: #000000;
  background: #fafafa;
  font-weight: normal;
}

.input-number {
  /* transform: scale(1.25); */
  width: 200px;
}

.input-number >>> .el-input__inner {
  width: 200px;
  text-align: right;
  font-size: 24px !important;
  font-weight: bold !important;
}
.conent > div {
  margin: 10px 0;
}
</style>
